@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.drivertargets

class ExtendedDriverTargetDto(
    val driverTarget: DriverTargetDto,
    val target: TargetDto,
    val driverTargetsCount: Int? = null
)